module.exports = __webpack_public_path__ + "5a5780cc29db7f7e6ab939b3dd409e52.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/Foto_Manja_Herrmann-8438.jpg
// module id = 474
// module chunks = 0